import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    lines: []
}

const lineSlice = createSlice({
    name: 'line',
    initialState,
    reducers: {
        setLines: (state, action) => {
            state.lines = action.payload
        }
    }
});


export const {setLines} = lineSlice.actions;
export default lineSlice.reducer;
